import { useState, useCallback } from 'react';

/**
 * Custom hook to manage row hover and expand states
 */
export const useRowInteractions = () => {
  const [hoveredRow, setHoveredRow] = useState<string | null>(null);
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());

  const handleRowHover = useCallback((issueId: string) => {
    setHoveredRow(issueId);
  }, []);

  const handleRowLeave = useCallback(() => {
    setHoveredRow(null);
  }, []);

  const toggleRow = useCallback((issueId: string) => {
    setExpandedRows(prev => {
      const newExpanded = new Set(prev);
      if (newExpanded.has(issueId)) {
        newExpanded.delete(issueId);
      } else {
        newExpanded.add(issueId);
      }
      return newExpanded;
    });
  }, []);

  return {
    hoveredRow,
    expandedRows,
    handleRowHover,
    handleRowLeave,
    toggleRow
  };
};
